<template>
  <div class="common-header">
    <div class="nav-row">
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="back-button" @click="goBack(back)">
        <path d="M13 5.5L6 12L13 18.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
      <div class="name-area">
        <img :src="data.icon" class="name-image" v-if="data.icon">
        <div class="name-text">{{ data.name ? $t(data.name) : data.name }}</div>
      </div>
      <div class="header-right"></div>
    </div>
    <div class="header-bottom">
      <slot name="bottom"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {RouteLocationNamedRaw, useRoute, useRouter} from 'vue-router';
import { goBack } from '@/script/common/routeScript';

export default defineComponent({
  name: "CommonHeader.vue",
  props: {
    data: {
      default: {
        name: '',
        icon: '',
      }
    },
    back: {
      default: '',
    }
  },
  setup(props, context) {

    return {
      goBack
    }
  }
})
</script>
